import React from 'react'
import Link from 'gatsby-link'

import CTAButton from '../CTA/cta'
import LogoGrid from '../LogoGrid/logo-grid'
import Markdown from '../Markdown/markdown'
import SubmitForm from '../SubmitForm/submit-form'
import Timeline from '../Timeline/timeline'

import ArrowRightIcon from '../../assets/icons/arrow-right-icon'

import { isColorBackground } from '../../util'
import './banner.scss'

class Banner extends React.Component {
  constructor(props) {
    super(props)
  }

  renderLinks(links) {
    return links.map(item => {
      return (
        <div key={ item.id }>
          <Link to={ `${item.url}` }>
            { item.question }
          </Link>
        </div>
      )
    })
  }

  renderCTAButton(ctaContent) {
    if (ctaContent) {
      return (
        <CTAButton
          title={ctaContent.title}
          url={ctaContent.url}
          style={ctaContent.style} />
      )
    } else {
      return null
    }
  }

  renderForm(content) {
    if (content) {
      return (
        <SubmitForm 
          content={content}
          localization={this.props.localization} />
      )
    }
    return null
  }

  renderContent(content) {
    if (content && content.body && content.body.body) {
      return (
        <div className="content-container">
          <Markdown content={ content.body.body } />
        </div>
      )
    }

    return null
  }

  renderTimeline(content) {
    if (content) {
      return <Timeline content={content} />
    } else {
      return null
    }
  }

  renderLogoGrid(content) {
    return (
      <LogoGrid content={content} lang={this.props.lang}/>
    )
  }
  
  renderComponents(items) {
    if (items) {
      return items.map(item => {
        if (item.__typename == 'ContentfulCtaButton') {
          return this.renderCTAButton(item)
        } else if (item.__typename == 'ContentfulSubmitForm') {
          return this.renderForm(item)
        } else if (item.__typename == 'ContentfulLogoGrid') {
          return this.renderLogoGrid(item)
        } else if (item.__typename == 'ContentfulContentBlock') {
          return this.renderContent(item)
        } else if (item.__typename == 'ContentfulTimeline') {
          return this.renderTimeline(item)
        }
      })
    }

    return null
  }

  render() {
    const localization = this.props.localization
    const backgroundColor = this.props.content.backgroundColor || 'white'
    const additionalClass = isColorBackground(backgroundColor) ? 'color-background' : ''
    const heading = this.props.content.heading || localization('global.faqTitle')
    const renderedComponents = this.renderComponents(this.props.content.items)

    return (
      <div className={ `banner-container ${additionalClass}` } data-cy="banner" style={{ backgroundColor }}>
        <h3>&lt; { heading } &gt;</h3>
        { this.props.content.extraBannerString ? <div className="description">
          <Markdown content={this.props.content.extraBannerString} />
        </div> : null}
          { this.props.content.questions ? 
              <div className="links-container">
                { this.renderLinks(this.props.content.questions) }
                <div className="cta-container">
                  <Link className="btn secondary" to={ `/${this.props.lang}/faq` }>
                    { this.props.localization('global.faqLink') } <ArrowRightIcon className="icon" />
                  </Link>
                </div>
              </div> : null
          }
        <div className="cta-container">
          { renderedComponents }
        </div>
      </div>
    )
  }
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner/banner.js